import React from 'react';
import './ArticleDetailsModal.css';

interface ArticleDetailsModalProps {
  articleNom: string;
  articleDescription: string;
  onClose: () => void;
}

const ArticleDetailsModal: React.FC<ArticleDetailsModalProps> = ({
  articleNom,
  articleDescription,
  onClose,
}) => {
  return (
    <div className="article-modal-backdrop" onClick={onClose}>
      <div
        className="article-modal-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="article-modal-header">
          <h2 className="article-modal-title">{articleNom}</h2>
          <button className="article-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="article-modal-body">
          {articleDescription ? (
            <p className="article-modal-description">{articleDescription}</p>
          ) : (
            <p className="article-modal-empty">Aucune description disponible.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailsModal;
